/* eslint-disable max-classes-per-file */

export interface ResponseGetSurveyInterface {
  status: boolean;
  message: string;
  data: SurveyDataInterface[];
}

export interface SurveyDataInterface {
  key: string;
  topic: number;
  title: string;
  image: string;
  mobileImage: string;
  question: string;
  condition: string;
  conditionMax: number;
  answer: Answer[];
  childQuestion: ChildQuestion | null;
  template: number;
}

export interface Answer {
  text: string;
  childStatus: boolean;
}

export interface ChildQuestion {
  question: string;
  condition: string;
  conditionMax: number;
  answer: Answer[];
}

export class ResponseSurveyData {
  key: string;

  topic: number;

  title: string;

  image: string;

  mobileImage: string;

  question: string;

  condition: string;

  conditionMax: number;

  answer: Answer[];

  childQuestion: ChildQuestion | null;

  template: number;

  constructor(data: SurveyDataInterface) {
    this.key = data.key || "";
    this.topic = data.topic || 1;
    this.title = data.title || "";
    this.image = data.image || "";
    this.mobileImage = data.mobileImage || "";
    this.question = data.question || "";
    this.condition = data.condition || "";
    this.conditionMax = data.conditionMax || 1;
    this.answer = data.answer || [];
    this.childQuestion = data.childQuestion || null;
    this.template = data.template || 1;
  }
}

export class ResponseGetSurvey {
  status: boolean;

  message: string;

  data: SurveyDataInterface[];

  constructor(data: ResponseGetSurveyInterface) {
    this.status = data.status || false;
    this.message = data.message || "";
    this.data = (data.data || []).map(
      (surveyData: SurveyDataInterface) => new ResponseSurveyData(surveyData),
    );
  }
}
